import { z } from "zod";

const tripDataSchema = z.object({
  uuid: z.uuid(),
  secondsDuration: z.number().nullable(),
  distance: z.number().nullable(),
  startDate: z.iso.datetime(),
  endDate: z.iso.datetime(),
  ecoDrivingScore: z.number().nullable(),
  smoothnessScore: z.number().nullable(),
  harshAccelerationsCount: z.number().nullable(),
  harshBrakesCount: z.number().nullable(),
  sharpTurnsCount: z.number().nullable(),
  departureAddress: z.string().nullable(),
  destinationAddress: z.string().nullable(),
});

const tripDriverSchema = z.object({
  uuid: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  analyticCode1: z.string().nullable(),
});

export const getTripsByVehiclesResponseSchema = z.array(
  z.object({
    vehicleUuid: z.string(),
    date: z.iso.datetime(),
    driver: tripDriverSchema.nullable(),
    count: z.number(),
    totalDistanceInKm: z.number(),
    hoursDuration: z.number(),
    usageStartDate: z.iso.datetime().nullable(),
    usageEndDate: z.iso.datetime().nullable(),
    trips: z.array(tripDataSchema),
  }),
);

export type GetTripsByVehiclesResponse = z.infer<
  typeof getTripsByVehiclesResponseSchema
>;
